<template>
  <TableVisualizationLayout :leftInfo="leftInfo" :leftAction="leftAction">
    <template slot="headerContent">
      <b-container id="form-filter-1">
        <CustomDivDownload>
          <template slot="periodOne">
            <div class="h-100 w-100 d-flex align-items-center">
              <div class="p3">CRM:</div>
              <div class="custom-div-select">
                <MultiSelectCrm @onSelectCrm="onSelectCrm" />
              </div>
            </div>
          </template>
          <template slot="periodTwo">
            <div class="h-100 w-100 d-flex align-items-center">
              <div class="p3">PERÍODO:</div>
              <div class="custom-div-start-date">
                <date-picker
                  datePickerId="dateStart"
                  :key="getKeyDate(startDate)"
                  :dataValue="startDate"
                  @datePickerChangedValue="onChangedStartDate"
                  :required="false"
                />
              </div>
            </div>
          </template>
          <template slot="periodThree">
            <div class="h-100 w-100 d-flex align-items-center">
              <div class="p3">ATÉ:</div>
              <div class="custom-div-end-date">
                <date-picker
                  datePickerId="endDate"
                  :key="2"
                  :dataValue="endDate"
                  @datePickerChangedValue="onChangedEndDate"
                  :required="true"
                />
              </div>
            </div>
          </template>
          <template slot="buttonSearch">
            <b-button
              class="my-4"
              style="margin-left: auto"
              variant="primary"
              :disabled="disableButton"
              @click="onGetListCommunicationReport()"
            >
              Gerar Relatório
            </b-button>
          </template>
        </CustomDivDownload>
        <div v-if="this.items.length > 0" class="align-right mb-2 mb-md-4">
          <div
            :class="isMobile() ? 'class-download' : 'class-download-right'"
            @click="downloadCommunicationReport()"
          >
            <div
              class="d-flex justify-content-center align-items-center img-custon-principal"
            >
              <img
                class="img-custon"
                src="@/assets/icons/MDI-microsoft-excel.svg"
              />
            </div>
            <div class="custom-text d-flex align-items-center">Download</div>
          </div>
        </div>
      </b-container>
    </template>
    <template slot="table" v-if="this.searched">
      <div class="scrollme">
        <b-table
          class="spaced-text"
          :fields="fields"
          :items="items"
          v-show="!this.loading"
          show-empty
          empty-text="Nenhuma informação para exibir!"
        >
          <template #cell(date)="data">
            {{ dateToLocaleDate(data.item.date) }}
          </template>
        </b-table>
      </div>
      <div v-show="this.loading">
        <b-skeleton-table :rows="10" :columns="6"></b-skeleton-table>
      </div>
    </template>
    <template slot="footerContent" v-if="this.searched">
      <div
        class="d-flex bd-highlight mb-3 justify-content-between"
        :class="isMobile() ? 'flex-column-reverse' : 'flex-row'"
        style="width: 100%"
      >
        <div class="mx-auto">
          <b-pagination
            v-model="page"
            :total-rows="totalSize"
            :per-page="perPage"
            aria-controls="my-table"
            size="lg"
          />
        </div>
      </div>
    </template>
  </TableVisualizationLayout>
</template>
<script>
import {
  getListCommunicationReport,
  downloadCommunicationReport,
} from "../../../services/communication/communication";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import TableVisualizationLayout from "../../../layouts/TableVisualizationLayout.vue";
import { createToast } from "../../../components/toast/toast";
import { inject } from "@vue/composition-api";
import { isMobile } from "../../../utils/mobile/mobile";
import { anchorBase64Download } from "../../../utils/anchor-base64-download/anchor-base64-download";
import MultiSelectCrm from "../../../components/multiselect-crm/MultiSelectCrm.vue";
import DatePicker from "../../../components/date-picker/DatePicker.vue";
import CustomDivDownload from "./CustomDivDownload.vue";
import { dateToLocaleDateTimeString } from "../../../utils/date/date-utils";

export default {
  setup() {
    const globalLoading = inject("globalLoading");

    return { globalLoading };
  },
  components: {
    TableVisualizationLayout,
    DatePicker,
    MultiSelectCrm,
    CustomDivDownload,
  },
  mounted() {},
  watch: {
    page: {
      handler() {
        if (!this.disableButton) this.onGetListCommunicationReport();
      },
    },
  },
  data: function () {
    return {
      leftInfo: "",
      loading: false,
      filterCrms: [],
      disableButton: true,
      searched: false,
      leftAction: {
        text: "Relatório de comunicados",
        onClick: this.leftActionClickHandler,
      },
      fields: [
        {
          key: "crm",
          label: "CRM",
          class: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "userName",
          label: "Nome do Cooperado",
          thStyle: { width: "25%" },
        },
        {
          key: "communicationName",
          label: "Nome do Comunicado",
          thStyle: { width: "25%" },
        },
        {
          key: "date",
          label: "Data e Hora",
          class: "text-center",
          thStyle: { width: "15%" },
        },
        {
          key: "event",
          label: "Nome do Botão",
          class: "text-right",
          thStyle: { width: "25%" },
          tdClass: "pr-5",
          thClass: "pr-5",
        },
      ],
      items: [],
      page: 1,
      perPage: 10,
      totalSize: 10,
      startDate: null,
      endDate: null,
    };
  },
  methods: {
    dateToLocaleDate: dateToLocaleDateTimeString,
    getKeyDate(date) {
      return date?.toString();
    },
    onChangedStartDate(value) {
      this.startDate = value;
      this.checkDisabledButton();
      this.resetResults();
    },
    onChangedEndDate(value) {
      this.endDate = value;
      this.checkDisabledButton();
      this.resetResults();
    },
    onSelectCrm(crms) {
      this.filterCrms = crms;
      this.checkDisabledButton();
      this.resetResults();
    },
    resetResults() {
      this.items = [];
      this.page = 1;
      this.totalSize = 10;
      this.searched = false;
    },
    checkDisabledButton() {
      const verify = (str) => str !== null && str !== undefined;
      const validDate = verify(this.startDate) && verify(this.endDate);
      if (validDate) {
        this.disableButton = false;
        return;
      }

      const crmsValid = this.filterCrms.length > 0;
      if (crmsValid) {
        this.disableButton = false;
        return;
      }

      this.disableButton = true;
    },
    isMobile: isMobile,
    async onGetListCommunicationReport() {
      try {
        this.loading = true;
        this.searched = true;
        const participantsResponse = await getListCommunicationReport(
          this.filterCrms,
          this.startDate,
          this.endDate,
          this.page - 1,
          this.perPage
        );
        this.items = participantsResponse.items;
        this.totalSize = participantsResponse.totalItems;
        this.loading = false;
      } catch (error) {
        createToast("Erro", "Não foi possível gerar o relatório.");
        console.error("onGetListCommunicationReport", error);
        this.loading = false;
      }
    },
    async downloadCommunicationReport() {
      try {
        this.globalLoading = true;
        const reportResponse = await downloadCommunicationReport(
          this.filterCrms,
          this.startDate,
          this.endDate
        );
        anchorBase64Download(
          null,
          "application/xls",
          "Relatório de Participações em Assembleias por CRM" +
            reportResponse.extension,
          reportResponse.fileBase64
        );
        this.globalLoading = false;
      } catch (error) {
        createToast("Erro", "Não foi possível gerar o relatório.");
        console.error("downloadCommunicationReport", error);
        this.globalLoading = false;
      }
    },
    leftActionClickHandler() {
      this.$router.push({
        path: RoutesPaths.communicationManagement.rootName(),
        replace: true,
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.header-container {
  display: flex;
  align-items: center; /* Alinha verticalmente todos os itens */
  justify-content: flex-start; /* Alinha os itens no início da linha */
  flex-wrap: wrap; /* Permite que os itens quebrem para a próxima linha, se necessário */
  margin: 1rem 0;
}
.div-container {
  flex: 1; /* Ocupa 100% no mobile */
  max-width: 100%; /* Limita a largura em telas maiores */
  margin-right: 0.5rem; /* Espaçamento entre os elementos */
  width: 100rem;
}
.div-container-mobile {
  @extend .div-container;
  flex: 1 1 50%;
}
.form-control {
  line-height: 3 !important;
}
.b-form-tags-input {
  margin-right: 0.5rem !important;
}
.b-form-tag-content {
  font-size: 1.2rem; /* Aumenta o tamanho da fonte do componente */
}
.class-download {
  cursor: pointer;
  height: 4.2rem;
  width: 13.8rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #00995d 0% 0% no-repeat padding-box;
}
.class-download-right {
  @extend .class-download; /* Reaproveita os estilos da classe base */
  margin-left: auto; /* Adiciona o novo estilo */
}
.img-custon-principal {
  width: 5rem;
}
.custom-text {
  color: var(--background-1);
  font-size: multiplier-default-font-size(3); // 16
}
.label-filter {
  font: normal normal normal 12px/14px Trebuchet MS;
  letter-spacing: 0px;
  color: #7a7e83;
  text-transform: uppercase;
  opacity: 1;
  margin-right: 1rem;
}

.custom-div-start-date {
  max-width: 100%;
  display: grid;
  grid-column: 0;
  grid-template-columns: 180px auto;
  text-transform: uppercase;
}

.custom-div-select {
  max-width: 100%;
  display: grid;
  grid-column: 0;
  grid-template-columns: 44rem auto;
  text-transform: uppercase;
  margin-left: 1rem;
}

.custom-div-end-date {
  max-width: 100%;
  display: grid;
  grid-column: 0;
  grid-template-columns: 208px auto;
  text-transform: uppercase;

  @media (min-width: 700px) {
    grid-template-columns: 180px auto;
  }
}
.button-custom {
  height: 3rem;
  width: 8rem;
  padding: 0;
}

button.button-custom {
  font-size: small;
}
</style>
